// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { ReportMessageImportanceLevel, ReportMessageSource } from '../../Utils/Enums/Constants';
import { Message } from './Message';
export class DirectReportMessage extends DirectMessageBaseClass {
    // TODO. ReportMessage: XMLMessage
    constructor(name, data, rawMessage = undefined) {
        super(Message.CODE_BUSINESS_REJECT_MESSAGE);
        this.Roundtrip = 0;
        this.Instrument = null;
        this.account = null;
        this.productType = null;
        this.ImportanceLevel = ReportMessageImportanceLevel.Normal;
        // TODO. UGLY. Refactor. Remove when BusinessRejectMessage is treated correctly.
        this.reject = false;
        this.SkipOnTicketViewer = false;
        this.source = ReportMessageSource.Unknown;
        this.Name = name;
        this.Data = data;
        this.RawMessage = rawMessage;
    }
}
